import { __rest } from "tslib";
import { clone, merge } from './utils';
export function series(target, params) {
    let [subject, defaults] = createSeries(target.subject(), params);
    let data = params.reactive ? params.data : null;
    let destroyed = false;
    // Never use shorthand properties as default values
    delete defaults.borderColor;
    delete defaults.wickColor;
    return {
        alive() {
            return !destroyed;
        },
        subject() {
            return subject;
        },
        update(nextParams) {
            const { type: nextType, data: nextData, reactive: nextReactive } = nextParams, nextOptions = __rest(nextParams, ["type", "data", "reactive"]);
            if (nextParams.type !== subject.seriesType()) {
                throw new TypeError('Can not change type of series in runtime. Report a bug please');
            }
            subject.applyOptions(merge(clone(defaults), nextOptions));
            if (!nextReactive) {
                data = null;
            }
            if (nextData !== data && nextReactive) {
                data = nextData;
                subject.setData(data);
            }
        },
        destroy() {
            if (target.alive()) {
                target.subject().removeSeries(subject);
            }
            destroyed = true;
        }
    };
}
function createSeries(chart, params) {
    switch (params.type) {
        case 'Area': {
            const series = chart.addAreaSeries(omit(params));
            const defaults = clone(series.options());
            series.applyOptions(omit(params));
            series.setData(params.data);
            return [series, defaults];
        }
        case 'Bar': {
            const series = chart.addBarSeries(omit(params));
            const defaults = clone(series.options());
            series.applyOptions(omit(params));
            series.setData(params.data);
            return [series, defaults];
        }
        case 'Candlestick': {
            const series = chart.addCandlestickSeries(omit(params));
            const defaults = clone(series.options());
            series.applyOptions(omit(params));
            series.setData(params.data);
            return [series, defaults];
        }
        case 'Histogram': {
            const series = chart.addHistogramSeries(omit(params));
            const defaults = clone(series.options());
            series.applyOptions(omit(params));
            series.setData(params.data);
            return [series, defaults];
        }
        case 'Line': {
            const series = chart.addLineSeries(omit(params));
            const defaults = clone(series.options());
            series.applyOptions(omit(params));
            series.setData(params.data);
            return [series, defaults];
        }
        case 'Baseline': {
            const series = chart.addBaselineSeries(omit(params));
            const defaults = clone(series.options());
            series.applyOptions(omit(params));
            series.setData(params.data);
            return [series, defaults];
        }
    }
}
function omit(params) {
    const { reactive, data, type } = params, rest = __rest(params, ["reactive", "data", "type"]);
    return rest;
}
